import React from 'react';

const HowItWorks = () => {
    // Definice dat pro 90minutové cvičení
    const steps90min = [
        { icon: 'fas fa-walking', title: '1. Část: Rozhýbání těla (15 min)', description: 'Delší rozcvička umožňuje důkladnější přípravu těla pro komplexnější a intenzivnější pohyby v následující fázi.' },
        { icon: 'fas fa-running', title: '2. Část: Pohyby (45 min)', description: 'Prodloužená část poskytuje prostor pro komplexnější a náročnější sestavy. Můžete se soustředit na hlubší protažení a posílení svalů.' },
        { icon: 'fas fa-spa', title: '3. Část: Meditace a zvuková terapie (30 min)', description: 'Závěrečná fáze nabízí delší čas pro hlubokou relaxaci a regeneraci, umožňující dosažení hlubšího stavu klidu a pohody.' },
    ];
    
    return (
        <section className="py-20 bg-gray-900 text-gray-200">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-8">
                    <h2 className="text-4xl font-bold mb-4">Jak Qigong probíhá?</h2>
                    <div className="w-24 h-1 bg-yellow-600 mx-auto"></div>
                </div>

                <p className="text-center text-gray-300 mb-12">90 minut pro pohyb, dech a závěrečnou relaxaci.</p>

                <div className="grid md:grid-cols-3 gap-8">
                    {steps90min.map((step, index) => (
                        <div key={index} className="text-center">
                            <div className="glass-effect w-24 h-24 rounded-full flex items-center justify-center mx-auto mb-6">
                                <i aria-hidden="true" className={`${step.icon} text-3xl gold-text`}></i>
                            </div>
                            <h3 className="text-xl font-bold mb-3">{step.title}</h3>
                            <p className="text-gray-400">{step.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default HowItWorks;
